function PostImagePlaceholder() {
  return (
    <div className='w-full h-full flex items-center justify-center bg-white/90'>
      <h1 className='text-xl font-bold text-black'>Sem imagem</h1>
    </div>
  )
}

export default PostImagePlaceholder
